import { useEffect } from 'react';
import { notification } from 'antd';
import i18n from '../i18n';

let notificationApi = null;

export const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    notificationApi = api;
    return () => {
      notificationApi = null;
    };
  }, [api]);

  return (
    <>
      {contextHolder}
      {children}
    </>
  );
};

const config = { placement: 'top', closeIcon: false, duration: 1 };

const UtilNotify = {
  notifySuccess: (title, description) => {
    if (title) title = i18n.t(title);
    if (notificationApi) {
      notificationApi.success({
        title,
        description,
        ...config,
      });
    } else {
      notification.success({ title, description });
    }
  },
  notifyError: (title, description) => {
    if (title) title = i18n.t(title);
    if (notificationApi) {
      notificationApi.error({
        title,
        description,
        ...config,
      });
    } else {
      notification.error({ title, description });
    }
  },
  notifyErrorServer: (title, description) => {
    if (title) {
      if (title.startsWith('Duplicate entry')) {
        if (title.includes('tbl_accounts')) {
          title = 'WARNING_THIS_ACCOUNT_NAME_ALREADY_EXISTS';
        }
      } else if (title.startsWith('There is no Account with this email')) {
        title = 'WARNNING_THERE_IS_NO_ACCOUNT';
      } else if (
        title.startsWith(
          'Invalid value, Invalid value, saveData.email field is required and cannot be empty & Must be valid email'
        )
      ) {
        title = 'WARNNING_EMAIL_REQUIRED_VALID';
      } else if (title.startsWith('check your password and try again')) {
        title = 'WARNNING_CHECK_YOUR_PASSWORD';
      }
      title = i18n.t(title);
    }
    if (notificationApi) {
      notificationApi.error({
        title,
        description,
        ...config,
      });
    } else {
      notification.error({ title, description });
    }
  },
  notifyInfo: (title, description) => {
    if (title) title = i18n.t(title);
    if (notificationApi) {
      notificationApi.info({
        title,
        description,
        ...config,
      });
    } else {
      notification.info({ title, description });
    }
  },
  notifyWarning: (title, description) => {
    if (title) title = i18n.t(title);
    if (notificationApi) {
      notificationApi.warning({
        title,
        description,
        ...config,
      });
    } else {
      notification.warning({ title, description });
    }
  },
};

export default UtilNotify;
